var _mask, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_466_84115",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.516 16.0961C21.1451 14.8674 21.5 13.4752 21.5 12C21.5 7.02944 17.4706 3 12.5 3C7.52944 3 3.5 7.02944 3.5 12C3.5 16.9706 7.52944 21 12.5 21C13.9653 21 15.3488 20.6498 16.5714 20.0286L21.5 22L20.516 16.0961Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.516 16.0961L19.6259 15.6403L19.4753 15.9345L19.5296 16.2605L20.516 16.0961ZM16.5714 20.0286L16.9428 19.1001L16.5223 18.9319L16.1184 19.1371L16.5714 20.0286ZM21.5 22L21.1286 22.9285L22.7785 23.5884L22.4864 21.8356L21.5 22ZM20.5 12C20.5 13.313 20.1844 14.5495 19.6259 15.6403L21.4061 16.5518C22.1057 15.1854 22.5 13.6373 22.5 12H20.5ZM12.5 4C16.9183 4 20.5 7.58172 20.5 12H22.5C22.5 6.47715 18.0228 2 12.5 2V4ZM4.5 12C4.5 7.58172 8.08172 4 12.5 4V2C6.97715 2 2.5 6.47715 2.5 12H4.5ZM12.5 20C8.08172 20 4.5 16.4183 4.5 12H2.5C2.5 17.5228 6.97715 22 12.5 22V20ZM16.1184 19.1371C15.033 19.6886 13.8043 20 12.5 20V22C14.1263 22 15.6647 21.611 17.0244 20.9201L16.1184 19.1371ZM21.8714 21.0715L16.9428 19.1001L16.2001 20.9571L21.1286 22.9285L21.8714 21.0715ZM19.5296 16.2605L20.5136 22.1644L22.4864 21.8356L21.5024 15.9317L19.5296 16.2605Z",
    fill: "#202635",
    mask: "url(#path-1-inside-1_466_84115)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 8.83599V7.23999H13.108V8.83599H11.5ZM11.5 16V9.71199H13.108V16H11.5Z",
    fill: "#202635"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.7821eef0.svg";
export { ForwardRef as ReactComponent };